<v-row>
  <v-col v-if="hasAllSortInfo" has="10">
    <fou-group>
      <div :class="[$style.certifyBox, $style.rowFlex]" v-if="result">
        <span :class="$style.certifyCheckDesc">
          <div class="mt-serif--size3 mt-serif--displayBold">
            {{$t('pages.submissions.components.upload.results.smart_sort.title1')}}
          </div>
          <div>
            {{$t('pages.submissions.components.upload.results.smart_sort.description1')}}
          </div>
        </span>
        <button :disabled="smartSort" class="mt-button" :class="$style.toggleButton" @click="smartSort = !smartSort">
          {{$t('pages.submissions.components.upload.results.smart_sort.button1')}}
        </button>
      </div>
      <div v-if="!result" :class="[$style.certifyBox, $style.rowFlex]">
        <span :class="$style.certifyCheckDesc">
          <div class="mt-serif--size3 mt-serif--displayBold">
            {{$t('pages.submissions.components.upload.results.smart_sort.title')}}
         </div>
         <div>
           {{$t('pages.submissions.components.upload.results.smart_sort.description')}}
         </div>
       </span>
       <button :disabled="smartSort" class="mt-button" :class="$style.toggleButton" @click="smartSort = !smartSort">
         {{$t('pages.submissions.components.upload.results.smart_sort.button')}}
       </button>
     </div>
    </fou-group>
  </v-col>
  <div class="col" v-else :class="$style.loading"
    v-tooltip="{content: $t('pages.submissions.components.upload.results.smart_sort.tool_tip'), placement: 'bottom'}">
    <load-animation></load-animation>
  </div>
</v-row>